exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2HViMDDP-MainHeadingRow-module-main-heading-row{padding-bottom:20px}", ""]);

// exports
exports.locals = {
	"main-heading-row": "_2HViMDDP-MainHeadingRow-module-main-heading-row",
	"mainHeadingRow": "_2HViMDDP-MainHeadingRow-module-main-heading-row"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/MainHeadingRow/MainHeadingRow.module.scss
// module id = 757
// module chunks = 0